/**
 * 站外来源：首屏快照（document.referrer + 落地 URL 查询参数）。
 * 须在 main.js 中最先 import，保证先于路由与其它逻辑执行。
 */

const EMPTY_SNAPSHOT = Object.freeze({
  landing_referrer: '',
  utm: Object.freeze({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: '',
  }),
  channel_param: '',
})

// 合并解析当前 URL 的查询参数：同时读取 location.search 与 hash 内 query，hash 优先覆盖
function parseQueryFromLocation() {
  // prettier-ignore
  try {
    const merged = new URLSearchParams()
    const search = typeof window !== 'undefined' && window.location.search ? window.location.search : ''
    if (search.length > 1) {
      new URLSearchParams(search.slice(1)).forEach((v, k) => merged.set(k, v))
    }
    const hash = typeof window !== 'undefined' && window.location.hash ? window.location.hash : ''
    const qi = hash.indexOf('?')
    if (qi !== -1) {
      new URLSearchParams(hash.slice(qi + 1)).forEach((v, k) => merged.set(k, v))
    }
    return merged
  }
  catch (e) {
    console.log('ta-landing parseQueryFromLocation', e)
    return new URLSearchParams()
  }
}

// 构建首屏来源快照：referrer + utm_* + channel 参数
function buildSnapshot() {
  const referrer = typeof document !== 'undefined' && document.referrer ? document.referrer : ''
  const params = parseQueryFromLocation()
  const utm = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || '',
  }
  const channelParam = params.get('channel') || ''
  return {
    landing_referrer: referrer,
    utm,
    channel_param: channelParam,
  }
}

// buildSnapshot 的安全包装，异常时返回空快照
function safeBuildSnapshot() {
  // prettier-ignore
  try {
    return buildSnapshot()
  }
  catch (e) {
    console.log('ta-landing safeBuildSnapshot', e)
    return {
      landing_referrer: EMPTY_SNAPSHOT.landing_referrer,
      utm: { ...EMPTY_SNAPSHOT.utm },
      channel_param: EMPTY_SNAPSHOT.channel_param,
    }
  }
}

// 模块加载时立即冻结一份首屏快照，避免后续路由跳转污染来源
const snapshot = safeBuildSnapshot()

// 对外暴露：取首屏 referrer 快照
export function getLandingReferrerSnapshot() {
  // prettier-ignore
  try {
    return snapshot.landing_referrer || ''
  }
  catch (e) {
    console.log('getLandingReferrerSnapshot', e)
    return ''
  }
}

// 解析站外来源归因字符串：UTM > channel 参数 > referrer 快照 > direct
export function resolveLandingExternalSource() {
  // prettier-ignore
  try {
    const { utm, channel_param, landing_referrer } = snapshot
    const hasUtm = utm.utm_source || utm.utm_medium || utm.utm_campaign || utm.utm_term || utm.utm_content
    if (hasUtm) {
      const parts = []
      if (utm.utm_source) parts.push(`utm_source=${utm.utm_source}`)
      if (utm.utm_medium) parts.push(`utm_medium=${utm.utm_medium}`)
      if (utm.utm_campaign) parts.push(`utm_campaign=${utm.utm_campaign}`)
      if (utm.utm_term) parts.push(`utm_term=${utm.utm_term}`)
      if (utm.utm_content) parts.push(`utm_content=${utm.utm_content}`)
      return `utm:${parts.join('&')}`
    }
    if (channel_param) {
      return `channel:${channel_param}`
    }
    if (landing_referrer) {
      return landing_referrer
    }
    return 'direct'
  }
  catch (e) {
    console.log('resolveLandingExternalSource', e)
    return 'direct'
  }
}

// 数数 super 属性：会话内站外归因一致，供 ta-init.js setSuperProperties 使用
export function getLandingTrafficSuperProps() {
  // prettier-ignore
  try {
    return {
      landing_referrer: snapshot.landing_referrer || '',
      landing_external_source: resolveLandingExternalSource(),
    }
  }
  catch (e) {
    console.log('getLandingTrafficSuperProps', e)
    return {
      landing_referrer: '',
      landing_external_source: 'direct',
    }
  }
}
